import React from "react";
import { withStyles } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {Link} from "gatsby";

const styles = {
  menu: {
    paddingRight: "6px"
  },
  title: {
    flexGrow: 1,
  },
  bar: {
    zIndex: 15,
    background: 'linear-gradient(45deg, #ff0084 30%, #ff6600 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  }
};

function MenuBar(props) {
  const {classes} = props;
  return (
    <AppBar position="static" className={classes.bar}>
      <Toolbar>
        <Typography align="left" color="secondary" className={classes.title} variant="h6" noWrap>
          gym.js
        </Typography>
        <Link to={`/`} className={classes.menu}>
          <Button color="secondary">Home</Button>
        </Link>
        <Link to={`/env/`} className={classes.menu}>
          <Button color="secondary">Environments</Button>
        </Link>
        <a href="https://ttumiel.github.io/gym.js/" className={classes.menu}>
          <Button color="secondary">Docs</Button>
        </a>
        <Link to={`/about/`} className={classes.menu}>
          <Button color="secondary">About</Button>
        </Link>
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(MenuBar);
